import {inlineError, streamify, tracer} from '@s-ui/decorators'
import {UseCase} from '@s-ui/domain'

/**
 * @implements UseCase
 */
@streamify('execute')
class UpdateUserAlertUseCase extends UseCase {
  constructor({repository, getCurrentUserService, fromUserAlertsParamsToRequestValueObjectMapper}) {
    super()
    this._repository = repository
    this._getCurrentUserService = getCurrentUserService
    this._fromUserAlertsParamsToRequestValueObjectMapper = fromUserAlertsParamsToRequestValueObjectMapper
  }

  /**
   * @return {Promise<Object, Error>}
   */
  @tracer({metric: 'UpdateUserAlertUseCase#execute'})
  @inlineError
  async execute({userAlert, activeEmail, activePush}) {
    const userEntity = await this._getCurrentUserService.execute()
    const userId = userEntity.getId()
    const {alertId} = userAlert

    const parsedUserAlert = this._fromUserAlertsParamsToRequestValueObjectMapper.map({
      alertId,
      userAlert,
      activeEmail,
      activePush
    })

    const [error, response] = await this._repository.updateUserAlert({
      alertId,
      userId,
      parsedUserAlert
    })

    if (error) return Promise.reject(error)

    return response
  }
}

export default UpdateUserAlertUseCase
